/**
 * The words a screen prints for a thing it was handed by id.
 *
 * James, from the staging box, Sep 27: *Successors shows "Area chair / co-chair · area af96ef1e"
 * instead of the area's name.* A uuid fragment on a director's screen is not a shorter name, it
 * is no name at all — it tells a reader nothing, it cannot be searched for, and it looks like a
 * fault because it is one.
 *
 * So there is one rule and one place for it: **a screen prints a name, or it says in words that
 * there isn't one.** The name comes from the API, which owns the join; where the API genuinely
 * has nothing — an area a run took back, a person erased — the screen says so in English.
 *
 * `tools/no-ids-on-screens.test.ts` reads `apps/web/src` on every push and refuses a uuid
 * fragment rendered into any screen.
 */

/** An area, for a reader: its name, or the plain truth that the row points at nothing. */
export function areaWords(name: string | null | undefined, areaId?: string | null): string {
  const n = (name ?? '').trim();
  if (n) return n;
  return areaId ? 'an area no longer here' : 'all areas';
}

/** A person, for a reader: their name, or the plain truth. */
export function personWords(name: string | null | undefined): string {
  return (name ?? '').trim() || 'someone no longer here';
}
